import { render, staticRenderFns } from "./ConfigureAffiliateWidget.vue?vue&type=template&id=7ba06334&scoped=true&"
import script from "./ConfigureAffiliateWidget.vue?vue&type=script&lang=js&"
export * from "./ConfigureAffiliateWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba06334",
  null
  
)

export default component.exports